module.exports = __webpack_public_path__ + "static/media/sr-graph-left.5a2358d5.svg";